
import './App.css';
import Dictionary from './component/Dictionary';
import Home from './component/Home';
import Navbar from './component/Navbar';
import {BrowserRouter, Route, Routes} from "react-router-dom"


function App() {
  return (
   <div style={{backgroundColor:"lightgreen", height:"100vh"}}>
   
   <Navbar/>
   <BrowserRouter>
   <Routes>
    <Route path='/' element={<Home/>}></Route>
    <Route path='/dictionary' element={<Dictionary/>}></Route>
   </Routes>

   </BrowserRouter>
    </div>
  );
}

export default App;
